module.exports = __webpack_public_path__ + "static/thumb-1-d8e8e78985f6a7d07df998a8e87bcb91.jpg";